import React from 'react'
import style from './PageLoader.module.css'

const PageLoader = () => {
  return (
    <div className={style.loadercontainer}>
            <span class={style.loader}></span>

    </div>

  )
}

export default PageLoader